/*
 * @Author: zxf
 * @Date: 2022-07-20 14:20:09
 * @LastEditors: zxf
 * @LastEditTime: 2022-07-27 16:16:51
 * @Description: 维保计划路由
 */
const wbjzRoutes = {
  path: 'wbjz',
  name: 'wbjz',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'list',
      name: 'wbjzList',
      component: () => import(/* webpackChunkName: "wbjzList" */'@/features/xfwbgl/wbjz/wbjzList.vue'),
      meta: {
        navtabTitle: '维保建筑列表',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    }
  ]
};

export default wbjzRoutes;
